module.exports = __webpack_public_path__ + "static/media/plaid_xact_example.e7fbe07f.png";